/**
 * @generated SignedSource<<0d5a256e1886eb310c19d52c16fbe20a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RevokeAPIKeysInput = {
  identities: ReadonlyArray<string>;
};
export type RevokeApiKeysMutation$variables = {
  input: RevokeAPIKeysInput;
};
export type RevokeApiKeysMutation$data = {
  readonly revokeAPIKeys: {
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly revokedKeys: ReadonlyArray<{
      readonly id: string;
      readonly identity: string;
      readonly revokedAt: string | null | undefined;
    }> | null | undefined;
  };
};
export type RevokeApiKeysMutation = {
  response: RevokeApiKeysMutation$data;
  variables: RevokeApiKeysMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "APIKey",
  "kind": "LinkedField",
  "name": "revokedKeys",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "revokedAt",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RevokeApiKeysMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RevokeAPIKeysPayload",
        "kind": "LinkedField",
        "name": "revokeAPIKeys",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "RevokeApiKeysMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RevokeAPIKeysPayload",
        "kind": "LinkedField",
        "name": "revokeAPIKeys",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "35ab27517ed1166806eace16837a1e5d",
    "id": null,
    "metadata": {},
    "name": "RevokeApiKeysMutation",
    "operationKind": "mutation",
    "text": "mutation RevokeApiKeysMutation(\n  $input: RevokeAPIKeysInput!\n) {\n  revokeAPIKeys(input: $input) {\n    problems {\n      __typename\n      message\n    }\n    revokedKeys {\n      id\n      identity\n      revokedAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7a4c3c2105043367d8cb6138049f4899";

export default node;
